import { Component, input, output } from '@angular/core';
import { EnumOption } from 'app/shared/models/agent.model';
import { FormaChips } from 'forma';

/**
 * Row of selectable answer chips shown under a question for faster flow.
 * Emits the chosen option; the parent decides what to do with it.
 */
@Component({
  selector: 'app-agent-quick-replies',
  imports: [FormaChips],
  host: { class: 'agent-quick-replies' },
  templateUrl: './agent-quick-replies.html',
  styleUrls: ['./agent-quick-replies.scss'],
})
export class AgentQuickReplies {
  readonly options = input.required<EnumOption[]>();
  readonly ariaLabel = input<string>('Quick replies');
  readonly select = output<EnumOption>();
}
